var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "auto" } },
    [
      _c("section", { staticClass: "modal-card-body section" }, [
        _c(
          "div",
          [
            _c("b-loading", {
              attrs: { active: _vm.loading, "is-full-page": "" },
              on: {
                "update:active": function ($event) {
                  _vm.loading = $event
                },
              },
            }),
            _c("div", { staticClass: "flex" }, [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button is-warning is-outlined is-small",
                    attrs: { id: "pickup-step-12" },
                    on: {
                      click: () => {
                        _vm.$emit("close")
                        _vm.$emit("nextTourStep", "mailTemplatesBack")
                      },
                    },
                  },
                  [
                    _c("b-icon", { attrs: { icon: "chevron-left" } }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
                  ],
                  1
                ),
              ]),
            ]),
            _vm.selectedGroup
              ? _c("div", { staticClass: "section" }, [
                  _c("div", { staticClass: "container" }, [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "pages.pickup_management.mail_templates.select_placeholder"
                              ),
                            },
                            model: {
                              value: _vm.selectedTemplate,
                              callback: function ($$v) {
                                _vm.selectedTemplate = $$v
                              },
                              expression: "selectedTemplate",
                            },
                          },
                          _vm._l(_vm.mailTemplates, function (template) {
                            return _c(
                              "option",
                              {
                                key: template.id,
                                domProps: { value: template },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(template.templateName) + " "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "column right-align buttons" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-info",
                          attrs: { id: "pickup-step-5" },
                          on: { click: _vm.newTemplate },
                        },
                        [_c("b-icon", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _vm.selectedTemplate
                        ? _c(
                            "button",
                            {
                              staticClass: "button is-danger",
                              on: { click: _vm.deleteTemplate },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.delete")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.selectedTemplate
              ? _c(
                  "div",
                  { staticClass: "container" },
                  [
                    _c("ValidationObserver", {
                      ref: "observer",
                      attrs: { tag: "form" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ valid }) {
                              return [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.mail_templates.template_name"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    id: "pickup-step-6",
                                                    name: "templateName",
                                                    type: "text",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedTemplate
                                                        .templateName,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.selectedTemplate,
                                                        "templateName",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "selectedTemplate.templateName",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.mail_templates.mail_content"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.selectedTemplate
                                                          .content,
                                                      expression:
                                                        "selectedTemplate.content",
                                                    },
                                                  ],
                                                  staticClass: "textarea",
                                                  attrs: {
                                                    id: "pickup-step-7",
                                                    name: "content",
                                                    type: "text",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.selectedTemplate
                                                        .content,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.selectedTemplate,
                                                        "content",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.mail_templates.subject"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: { rules: { required: true } },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("b-input", {
                                                  attrs: {
                                                    id: "pickup-step-8",
                                                    name: "subject",
                                                    type: "text",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedTemplate
                                                        .subject,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.selectedTemplate,
                                                        "subject",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "selectedTemplate.subject",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-tooltip",
                                  {
                                    staticStyle: { "margin-top": "1rem" },
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.collect_confirmation.sender_hint"
                                      ),
                                      position: "is-right",
                                    },
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "pages.pickup_management.collect_confirmation.sender"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("b-icon", {
                                      staticClass: "is-small",
                                      attrs: { icon: "info", type: "is-info" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("ValidationProvider", {
                                  attrs: { rules: "email" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "1rem",
                                                },
                                                attrs: {
                                                  type:
                                                    errors.length > 0 &&
                                                    _vm.selectedTemplate.sender
                                                      ? "is-danger"
                                                      : "",
                                                },
                                              },
                                              [
                                                _c("b-input", {
                                                  attrs: {
                                                    name: "subject",
                                                    type: "text",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedTemplate
                                                        .sender,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.selectedTemplate,
                                                        "sender",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "selectedTemplate.sender",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b",
                                      {
                                        staticClass: "sub-titl9",
                                        attrs: { id: "pickup-step-9" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "pages.pickup_management.mail_templates.language"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "pages.pickup_management.mail_templates.language_tooltip"
                                          ),
                                          position: "is-right",
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          staticClass: "is-small",
                                          attrs: {
                                            icon: "info",
                                            type: "is-info",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "b-field",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "navbar-item has-dropdown is-hoverable",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "navbar-link" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: `https://flagcdn.com/w20/${_vm
                                                      .getLocalFlagString(
                                                        _vm.selectedTemplate
                                                          .lang
                                                      )
                                                      .toLowerCase()}.png`,
                                                    alt: "flag",
                                                  },
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "ml-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getLangName(
                                                          _vm.selectedTemplate
                                                            .lang
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "navbar-dropdown",
                                              },
                                              _vm._l(
                                                _vm.langs,
                                                function (lang) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: lang,
                                                      staticClass:
                                                        "navbar-item hoverable",
                                                      attrs: { value: lang },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.selectLang(
                                                            lang
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: `https://flagcdn.com/w20/${_vm
                                                            .getLocalFlagString(
                                                              lang
                                                            )
                                                            .toLowerCase()}.png`,
                                                          alt: "flag",
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getLangName(
                                                              lang
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "pages.pickup_management.mail_templates.misc"
                                      ),
                                    },
                                  },
                                  [
                                    _c("ValidationProvider", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.selectedTemplate
                                                          .misc,
                                                      expression:
                                                        "selectedTemplate.misc",
                                                    },
                                                  ],
                                                  staticClass: "textarea",
                                                  attrs: {
                                                    id: "pickup-step-10",
                                                    name: "misc",
                                                    type: "text",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.selectedTemplate.misc,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.selectedTemplate,
                                                        "misc",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-info is-fullwidth",
                                    class: { "is-loading": _vm.isSubmitting },
                                    attrs: {
                                      id: "pickup-step-11",
                                      disabled: !valid,
                                      type: "submit",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("global.submit")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2636336355
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }